if (!customElements.get("nss-menu")) {
    customElements.define("nss-menu", class NSSMenu extends HTMLElement {
            constructor() {
                super();
                this.selectors = {
                    nav: ".js-nss-nav",
                    triggerContainer: ".js-nss-submenu",
                    triggerButton: ".js-nss-submenu-toggle",
                    menuHolder: ".js-nss-mega-menu-holder",
                    overlay: ".js-nss-mega-menu-overlay",
                    mobileMenuToggle: ".js-nss-menu-mob-toggle",
                };
            }

            connectedCallback() {
                this.menuHolder = this.querySelectorAll(this.selectors.menuHolder);
                this.html = document.querySelector('html')
                this.menuHolder.forEach(el => {
                    const html = el.innerHTML;
                    const megaMenu = this.querySelector(`.js-nss-mega-menu[data-megamenu="${el.getAttribute("data-menu")}"]`);
                    if (megaMenu != null) {
                        megaMenu.innerHTML = html;
                    }
                });

                setTimeout(() => {
                    this.navbar = this.querySelector(this.selectors.nav);
                    this.triggerContainers = this.querySelectorAll(this.selectors.triggerContainer);
                    this.triggerButton = this.querySelectorAll(this.selectors.triggerButton);
                    this.mobileMenuToggle = document.querySelectorAll(this.selectors.mobileMenuToggle);
                    // Show the menu on mouse hover of the trigger

                    this.triggerContainers.forEach(triggerContainer => {

                        const triggerButton = triggerContainer.querySelector(this.selectors.triggerButton);


                        triggerContainer.addEventListener('mouseover', (e) => {

                            if (window.matchMedia('(min-width: 990px)').matches) {
                                const overlay = e.target.closest('.js-nss-mega-menu-overlay');

                                if (overlay) {
                                    this.hideMenu();
                                } else {
                                    this.showMenu(triggerContainer);
                                }
                            }

                        });


                        // Hide the menu when mouse hover leaves both the trigger and menu fly-out, but only after a short delay to help people jerky mouse movements (like those using head/eye trackers)
                        triggerContainer.addEventListener('mouseout', () => {

                            if (window.matchMedia('(min-width: 990px)').matches) {
                                this.hideMenu();
                            }

                        });

                        // Hide the menu when the user tabs out of it
                        triggerContainer.addEventListener('keydown', (e) => {
                            this.triggerKeydownHandler(e)
                        });

                        // Toggle the menu when the trigger is activated (works for both mouse and keyboard users)
                        triggerButton.addEventListener('click', (e) => {
                            this.toggleMenu(e, triggerContainer)
                        });
                    });
                    // Close the menu when the user activates something outside the navbar.
                    document.body.addEventListener('click', (e) => {
                        this.handleBodyClick(e)
                    });
                    this.mobileMenuToggle.forEach(el=>{
                        el.addEventListener('click', () => {
                            this.html.classList.toggle('is-mobile-menu-show');
                        })
                    })
                }, 100);
                this.header = document.querySelector(".nss-header");

                // Throttle handleResize on scroll using rAF — avoids forced reflow on every scroll event
                let resizePending = false;
                const throttledResize = () => {
                    if (!resizePending) {
                        resizePending = true;
                        requestAnimationFrame(() => {
                            this.handleResize();
                            resizePending = false;
                        });
                    }
                };
                window.addEventListener("scroll", throttledResize, { passive: true });

                // Use ResizeObserver instead of mouseover to react to header size changes
                if (this.header) {
                    new ResizeObserver(() => this.handleResize()).observe(this.header);
                }

                // Run once on load
                this.handleResize();

                const body = document.body;

                let lastScrollY = window.scrollY || window.pageYOffset;

                function toggleBodyClasses() {
                    const scrollY = window.scrollY || window.pageYOffset;
                    const vh100 = window.innerHeight;

                    // --- 100vh scroll state ---
                    if (scrollY > vh100) {
                        body.classList.add('is-scrolled-100vh');
                    } else {
                        body.classList.remove('is-scrolled-100vh');
                    }

                    // --- scroll direction (show header on scroll up) ---
                    if (scrollY > 10) {
                        if (scrollY < lastScrollY) {
                            body.classList.add('is-show-header');
                        } else {
                            body.classList.remove('is-show-header');
                        }
                    } else {
                        body.classList.remove('is-show-header');
                    }

                    lastScrollY = scrollY;
                }

                window.addEventListener('scroll', toggleBodyClasses, { passive: true });
                window.addEventListener('resize', toggleBodyClasses);

                toggleBodyClasses();
                document.querySelector(".header__search")?.addEventListener('click', ()=>{
                    this.html.classList.remove('is-mobile-menu-show');
                });

            }

            handleResize() {
                const headerHeight = (window.matchMedia('(min-width: 990px)').matches) ? this.header?.offsetHeight || 0 : 0;
                const headerTopOffset = this.header?.getBoundingClientRect()?.top || 0;
                const height = window.visualViewport.height;
                document.documentElement.style.setProperty('--nss-menu-offset', `${headerHeight + (headerTopOffset>0?headerTopOffset:0)}px`);
                document.documentElement.style.setProperty('--nss-menu-mob-height', `${height-(headerHeight + (headerTopOffset>0?headerTopOffset:0) + 68) }px`);
            }

            /**
             Menu visibility
             */
            showMenu(triggerContainer) {
                this.hideMenu();
                const triggerButton = triggerContainer.querySelector(this.selectors.triggerButton);
                triggerButton.setAttribute('aria-expanded', true);
                triggerContainer.classList.add("is-submenu-show");
                triggerContainer.querySelector(".nss-mega-menu").style.overflow = "hidden";
                this.html.classList.add('is-mega-menu-show');
            }

            hideMenu() {
                this.triggerContainers.forEach(triggerContainer => {
                    triggerContainer.classList.remove("is-submenu-show");
                    triggerContainer.querySelector(".nss-mega-menu").style.overflow = "";
                })
                this.triggerButton.forEach(triggerButton => {
                    triggerButton.setAttribute('aria-expanded', false);
                });

                this.html.classList.remove('is-mega-menu-show');
            }

            toggleMenu(e, triggerContainer) {
                e.preventDefault();
                if (triggerContainer.classList.contains("is-submenu-show")) {
                    this.hideMenu();
                } else {
                    this.showMenu(triggerContainer);
                }
            }


            /**
             Event handlers
             */
            handleBodyClick(e) {
                if (!this.navbar.contains(e.target)) {
                    this.hideMenu();
                }
            }

            triggerKeydownHandler(e) {
                const triggerContainer = this.querySelector(`${this.selectors.triggerContainer}.is-submenu-show`);
                if (triggerContainer != null) {
                    const menuItem = triggerContainer.querySelectorAll(`a, button`);
                    let lastMenuItem = undefined;
                    // Hide the menu when a keyboard user tabs out of it or presses Escape
                    if (menuItem.length > 0) {
                        lastMenuItem = menuItem[menuItem.length - 1]; // Get the last link
                    }
                    if ((e.key === 'Tab' && !e.shiftKey && e.target === lastMenuItem) || e.key == 'Escape') {
                        this.hideMenu();

                        // Move focus back to the menu toggle button on Escape
                        if (e.key == 'Escape') {
                            this.triggerButton.focus();
                        }
                    }
                }
            }

        }
    )
}